import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotTravelTimesApiMeta } from "../apiMeta";
import {
  type TravelTimesInput,
  travelTimesInputSchema,
} from "./shared/travelTimeRoutes.input";
import {
  type TravelTimeRoute,
  travelTimeRouteSchema,
} from "./shared/travelTimeRoutes.output";

/**
 * Metadata for the fetchTravelTimes endpoint
 */
export const travelTimesMeta = {
  functionName: "fetchTravelTimes",
  endpoint: "/getTravelTimesAsJson",
  inputSchema: travelTimesInputSchema,
  outputSchema: travelTimeRouteSchema.array(),
  sampleParams: {},
  endpointDescription: "List travel time data for all available routes.",
} satisfies EndpointMeta<TravelTimesInput, TravelTimeRoute[]>;

const { fetch, useHook } = createFetchAndHook<
  TravelTimesInput,
  TravelTimeRoute[]
>({
  api: wsdotTravelTimesApiMeta,
  endpoint: travelTimesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/travelTimeRoutes.endpoints").travelTimeRoutesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving travel time data for all available routes
 */
export const fetchTravelTimes: FetchFactory<
  TravelTimesInput,
  TravelTimeRoute[]
> = fetch;

/**
 * React Query hook for retrieving travel time data for all available routes
 */
export const useTravelTimes: HookFactory<TravelTimesInput, TravelTimeRoute[]> =
  useHook;
